module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_4_3_w_400.67b0f01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_400.jpg
// module id = ikVg
// module chunks = 0